module.exports = __webpack_public_path__ + "static/img/hq-guide-step-2.7c3e2a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hq-guide-step-2.png
// module id = 727
// module chunks = 8